import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    pageContainer:{
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    root: {
      maxWidth: "100%",
    },
    backButton: {
      marginRight:theme.spacing(2)
    },
    spsContainer:{
      marginTop:"20px",
      height: "2740px",
      overflow:"hidden",
    }
    
  }));

  export default function UtzonSPS() {
    const classes = useStyles();
    const LinkBehavior = React.forwardRef((props, ref) => (
      <RouterLink ref={ref} to="/" {...props} />
    ));
return(<div>
    <AppBar position="static">
      <Toolbar>
      <IconButton component={LinkBehavior} edge="start" className={classes.backButton} color="inherit" aria-label="back">
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" className={classes.title}>
          Vidensrummet
        </Typography>
        
      </Toolbar>
      
    </AppBar>
  <div className={classes.spsContainer}><iframe title="Spørgeskema til Arkitekturformidler" src="https://docs.google.com/forms/d/e/1FAIpQLSdHojBvHtwB4kzM1tolcdduf0KWJZzbvivC7ejiYHPDLkGeOA/viewform?embedded=true" width="740" height="2844" frameBorder="0" marginHeight="0" marginWidth="0">Indlæser…</iframe></div></div>);
  }
